/**
 * FE-C2g batch-5: Tenant ACL — user-scopes + tenant-delegations contract paths.
 */

import { buildContractPath } from "./api/contract-client.js";

export const TENANT_CONSOLE_TIMEOUT_MS = 20000;

export function buildGetAdminUserScopesChildrenPath() {
  return buildContractPath("get__admin_user-scopes-children");
}

/** @param {string} subAdminUsername */
export function buildGetAdminUserScopesPath(subAdminUsername) {
  return buildContractPath("get__admin_user-scopes_p", { pathParams: [subAdminUsername] });
}

/** @param {string} subAdminUsername @param {string} userUsername */
export function buildPostAdminUserScopePath(subAdminUsername, userUsername) {
  return buildContractPath("post__admin_user-scopes_p_p", {
    pathParams: [subAdminUsername, userUsername],
  });
}

/** @param {string} subAdminUsername @param {string} userUsername */
export function buildDeleteAdminUserScopePath(subAdminUsername, userUsername) {
  return buildContractPath("delete__admin_user-scopes_p_p", {
    pathParams: [subAdminUsername, userUsername],
  });
}

export function buildGetAdminTenantDelegationsPath() {
  return buildContractPath("get__admin_tenant-delegations");
}

export function buildPostAdminTenantDelegationsPath() {
  return buildContractPath("post__admin_tenant-delegations");
}

/** @param {string} granteeUsername */
export function buildDeleteAdminTenantDelegationPath(granteeUsername) {
  return buildContractPath("delete__admin_tenant-delegations_p", { pathParams: [granteeUsername] });
}
